import stepTypes from 'components/Booking-new/modules/Steps/types';
import { updateURL } from 'components/Booking-new/utils/helpers';

const updateStateByLocation = (paramValue, state = null, key = 'location') => {
  if (paramValue === null || state === null) {
    updateURL(key);
    return state || {};
  }

  const locationSteps = state?.allSteps?.find(({ type }) => type === stepTypes.location);
  if (typeof locationSteps === 'undefined') {
    updateURL(key);
    return state;
  }

  const locationBasedOnParam = locationSteps?.data?.locations?.find(
    ({ location, code }) => location === paramValue || code === paramValue,
  );
  if (typeof locationBasedOnParam === 'undefined') {
    updateURL(key);
    return state;
  }

  const locationStepIndex = state?.allSteps?.findIndex(({ type }) => type === stepTypes.location);
  const currentStep = locationStepIndex <= 1 ? 1 : 0; // If the location step is in the first place, move to the next step
  return {
    ...state,
    activeStep: currentStep,
    userData: {
      ...(state.userData || {}),
      [stepTypes.location]: {
        selectedLocation: locationBasedOnParam,
        isSelected: true,
      },
    },
  };
};

export default updateStateByLocation;
